import React from 'react';
import { Typography } from '@mui/material';
import { splitFrenchDateTime } from '../utils/formatDateTimeFr';

type Props = {
  createdAt?: string | null;
  prefix?: string;
  variant?: 'caption' | 'body2';
};

/** Date de création + heure côte à côte (cartes annonces). */
export const AnnouncementCreatedAtCaption: React.FC<Props> = ({
  createdAt,
  prefix,
  variant = 'caption',
}) => {
  const parts = splitFrenchDateTime(createdAt);
  if (!parts) return null;

  return (
    <Typography variant={variant} color="text.secondary" component="span">
      {prefix ? `${prefix} ` : null}
      {parts.date} à {parts.time}
    </Typography>
  );
};
